export class Tween<T>
{
    public from:T;
    public to:T;
    public duration:number = 1;
    public time:number = 0;
    
    public finished() {return this._finished;};

    private _finished = false;
    // TODO: easing

    public constructor(from?:T, to?:T, duration?:number)
    {
        if (typeof from != "undefined") this.from = from;
        if (typeof to != "undefined") this.to = to;
        if (typeof duration != "undefined") this.duration = duration;
    }

    public value():T
    {
        let t:number = this.time / this.duration;

        if (typeof this.from == "number" && typeof this.to == "number")
        {
            let from:number = this.from as number;
            let to:number = this.to as number;

            return ((1 - t) * from + t * to) as unknown as T;
        }        

        return null;
    }

    public update(deltaTime:number)
    {
        this.time += deltaTime;

        if (this.time > this.duration)
        {
            this.time = this.duration;
            this._finished = true;
        }            

        if (this.time < 0)            
            this.time = 0;
    }

    public reset()
    {
        this.time = 0;
        this._finished = false;
    }
}